import React, {useRef, useState, useMemo} from 'react';
import ErrorsList from './ErrorsList';
import JoditEditor from "jodit-react";
import moment from "moment";
import { Button, Modal } from 'react-bootstrap';

const Jodit = React.lazy(() => {
  return import("jodit-react");
});

const PostForm = (props) => {
  const [saving, setSaving] = useState(false);

  const [state, setState] = React.useState({
    _id: props.post ? props.post._id : 0,
    author: props.post ? props.post.author : '',
    authorEmail: props.post ? props.post.authorEmail : '',
    title: props.post ? props.post.title : '',
    sapo: props.post ? props.post.sapo : '',
    createdAt: props.post ? props.post.createdAt : Date.now(),
    category: props.post ? props.post.category : '',
    postType: props.post ? props.post.postType : 0,
    groupId: props.post ? props.post.groupId : 0,
    tags: props.post ? props.post.tags : [],
    mainImage: props.post ? props.post.mainImage : '',
    thumbnail: props.post ? props.post.thumbnail : '',
    body: props.post ? props.post.body : '',
    createdBy: props.auth ? props.auth._id : 0,
    errors: ''
  });

  const [author, setAuthor] = React.useState({
    editor: null,
    authorName: '',
    authorIns: '',
    authorOrcid: '',
    errors: ''
  });

  const orcidTemplate = '<a href="{authorOrcid}" target="_blank"><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAABGdBTUEAALGOfPtRkwAAACBjSFJNAAB6JQAAgIMAAPn/AACA6QAAdTAAAOpgAAA6mAAAF2+SX8VGAAAE7ElEQVR42gyMKxLCQBAF++2SQhBUKhaJ4wI5AzaXXJtD5AC43AARt1X8ameYp1p0P5UygwvrfrTLE1niKMP6yvt1umXTXYkJ+dWdgZjEHrwhVmtazskfn2i+BpnEWDsO8ePh/gUQCwMWAFSn/e8XewUTA0MQA9N/LpBCsGoogFqkBhTzAVpW/Yvx//p//xnbgTJX0c0CCCAmDNMZ/yf8Zvp/4O9flhhGBgYuBgKAkfE/16//jNH/GBgPMDIyJqLLAwQQ039Ux5UxMP+bD9Ql8u//b4bff78BXfuXgaAlEEqEkYFxHpAuR5YDCCAWRv6PYBv+cf2OZ2T63wkS/PvvJ4M4rzGDrIADw41Xyxm+/nrBwMTIwkAMAEZnx3uOPy////m/AOgrBoAAYhIVecfAI/xB/T/PjwkwRX///2KQ4rNk0BCLZODnUGQA+QaqHQnjBj9Z//f/4/ylzs79jQEggBg33Fdg+PdVcOn3n5xRwPCERuI/BjYWHgZuNimGjz/uAS34y/Dv3y+gsf+QIvof2CImRjYGZiZWRECB5RgZuNh+LGfj/BQFEEAsn9+JazMyMgUzMSJc9e//HwZednkGOQFHhmuvljD8/POBQVM8FugbBbCBwJQDtPA3w5dfzxiefTrG8PbrNXAQMjIywyKe4etv9qCPP0W0AQKIie0vSwAwxbKjJFNgEAlxaQANjWFgZ+YHu1ZZ2IdBUciDgZtdAugzCQYBTlUGLaClHuoLGYxlioCmMqEkCCZGBnb2fywBAAHE8pflnxWy92DpAhLu/+HBArLk2afjDAfuFjEwM7KCUzgrMw+DulgYg55kGlDVX4ZzTyYwsEB9AY4m1n9WAAHEBPSOGgPRgBGcjSGYgeHX348M559MZLj5aiWDllg0gwCHMlKCADtTFSCAmIARIsTAQIoVTHDMBPQJMxM7w913m8HhD0raf4GJARHUjMIAAcTEQCFgBEbuj9/vwWwOVkGUlAYCAAEECqJ3lFgAShC87NJg9tdfL+EpCWL4/7cAAQQKolvEG/cfHNkwDMrxIADKkL//fmV48ekkMAGwIalmuA0QQExMf5iOEcqZyOHPzMQGx3zAfGGt0AIsUhwZzj+dDM4X8CIFlDB/sx4DCCCWH8x/NrAwMNUCI4Md2aUQhYxgQ2E6ZATsGXy1VoPZoKTKwSoETElfGE4+amW4/Xod0FIO5CL95z/2PxsAAohFgOvj1b8/udd+/8seBcvNoJTx5utlhgvPpgJz8XtguDIxXH+1lIGHXQpuMajo+PzzMcPLL2fBhSHIcEZofgIVFTxsP9dy8ny+ChBAjHvP2DP8AFYen5h+nQAaL4jIaL8Y/vz7AcxM3GBf/Pn3DVwmoaYQZnDRgV7SAtPRB9afzBbs//7fBAgglh+/eUD23mJl/F74k+37AkZ4ELEysDGzIsp1Ji6ikwInA0sBEzvLTZBzAAKI5etTLnAhzsDGvpBR5oc4sFLuxCw6SMgX/xkr+L8xL2T9C0k6AAHExACy5i+8mO8CVvqgau8N2FLSwBtg2CQB6U6QWf///wdjgABiAjuWESUpLmD5x2DPxPprCVD+GxEGf2P6z7wEGD0OQGPno0sCBBALZlYC58Brf9m/xf7/I9jJwPTHF+htK6CPQIWiMFTZWyAGZtD/x4AO2sL8j+XyX1ACwOJpgAADAO3QwuOM1muGAAAAAElFTkSuQmCC" style="width: 27px; height: 27px;" width="27px" height="27px"></a>';
  const authorTemplate = '<br>{authorOrcid} <strong><em>{authorName}</em></strong>{authorIns}<br>';

  const editor = useRef(null)
	const [content, setContent] = React.useState(props.post ? props.post.body : '')

  React.useEffect(() => {
    setState({
      _id: props.post ? props.post._id : 0,
      author: props.post ? props.post.author : '',
      authorEmail: props.post ? props.post.authorEmail : '',
      title: props.post ? props.post.title : '',
      sapo: props.post ? props.post.sapo : '',
      createdAt: props.post ? props.post.createdAt : Date.now(),
      category: props.post ? props.post.category : '',
      postType: props.post ? props.post.postType : 0,
      groupId: props.post ? props.post.groupId : 0,
      tags: props.post ? props.post.tags : [],
      mainImage: props.post ? props.post.mainImage : '',
      thumbnail: props.post ? props.post.thumbnail : '',
      body: props.post ? props.post.body : '',
      createdBy: props.auth ? props.auth._id : 0,
      errors: ''
    });

    setContent(props.post ? props.post.body : '');
  }, [props])

  // const config = {
  //   zIndex: 0,
  //   readonly: false,
  //   activeButtonsInReadOnly: ['source', 'fullsize', 'print', 'about'],
  //   toolbarButtonSize: 'middle',
  //   theme: 'default',
  //   enableDragAndDropFileToEditor: true,
  //   saveModeInCookie: false,
  //   spellcheck: true,
  //   editorCssClass: false,
  //   triggerChangeEvent: true,
  //   minHeight: 200,
  //   maxHeight: 500,
  //   direction: 'ltr',
  //   language: 'en',
  //   debugLanguage: false,
  //   i18n: 'en',
  //   tabIndex: -1,
  //   toolbar: true,
  //   enter: 'P',
  //   useSplitMode: false,
  //   colorPickerDefaultTab: 'background',
  //   imageDefaultWidth: 100,
  //   removeButtons: ['source', 'fullsize', 'about', 'outdent', 'indent', 'video', 'print', 'table', 'fontsize', 'superscript', 'subscript', 'file', 'cut', 'selectall'],
  //   disablePlugins: ['paste', 'stat'],
  //   events: {},
  //   textIcons: false,
  //   uploader: {
  //     insertImageAsBase64URI: true
  //   },
  //   placeholder: '',
  //   showXPathInStatusbar: false
  // };
  const isSSR = typeof window === "undefined";

  var jodit = null;

  const config1 = {
    useSearch: false,
    spellcheck: false,
    enter: "br",
    defaultMode: "1",
    toolbarAdaptive: false,
    toolbarSticky: false,
    showCharsCounter: false,
    showWordsCounter: true,
    showXPathInStatusbar: false,
    askBeforePasteHTML: false,
    askBeforePasteFromWord: false,
    minHeight: 200,
    maxHeight: 500,
    minWidth: null,
    buttons: [
        'source', '|',
        'bold',
        'strikethrough',
        'underline',
        'italic', '|',
        'ul',
        'ol', '|',
        'outdent', 'indent',  '|',
        'font',
        'fontsize',
        'paragraph', '|',
        'image',
        'video',
        'table',
        'link', '|',
        'align', 'undo', 'redo', '|',
        'hr',
        'eraser',
        'copyformat', '|',
        'symbol',
        'fullsize',
        {
          name: 'insertAuthor',
          iconURL: '/images/orcid.png',
          tooltip: 'Insert author',
          exec: (editor) => {
            handleShow();
          }
        },
        {
          name: 'insertDate',
          tooltip: 'Insert current Date',
          exec: (editor) => {
            editor.s.insertHTML(moment(new Date()).format('MMMM DD, YYYY'));
          }
        }
    ],
    editorCssClass: "alic",
    uploader: {
      insertImageAsBase64URI: true
    },
    placeHolder: "",
    controls: {
      fontsize: {
        list:["8","9","10","11","12","14","16","18","24","30","36","48","60","72","96","100"]},
      font: {
        command: "fontname",
        list: {
          "": "Default",
          "'Open Sans',sans-serif": "Open Sans",
          "Helvetica,sans-serif": "Helvetica",
          "Arial,Helvetica,sans-serif": "Arial",
          "Georgia,serif": "Georgia",
          "Impact,Charcoal,sans-serif": "Impact",
          "Tahoma,Geneva,sans-serif": "Tahoma",
          "'Times New Roman',Times,serif": "Times New Roman",
          "Verdana,Geneva,sans-serif": "Verdana"
        }
      },
      // code: {
      //   name: 'code',
      //   iconURL: 'someiconurl.com',
      //   tooltip: 'Insert Code Block',
      //   exec: function (editor) {
      //     handleShow();
      //     //editor.execCommand('formatBlock', false, 'code');
      //   },        
      //   isActive: (editor, control) => {
      //     console.log("test", author, editor);
      //     const current = editor.s.current();
      //     return Boolean(
      //       current //&& Jodit.modules.Dom.closest(current, 'code', editor.editor)
      //     );
      //   },
      // }
    },
    events: { 
      afterInit: (instance) => { jodit = instance; } 
    }
  };

  const config = useMemo(
    () => (config1),
    []
  );

  const renderErrors = () => {
    const { errors } = state;
    if (errors) {
      return <ErrorsList errors={errors} />;
    }
  };

  const onSubmit = e => {
    setSaving(true);

    let body = content;

    const errors = [];
    if (!body || body.length < 24) {
      errors.push('The post body should have at least 24 characters');
    }

    setState({...state, body: body });
    
    if (errors.length >= 1) {
      setState({...state, errors });
    } else {
      const post = state;
      post.body = body;
      props.onSubmit(post);
    }

    setSaving(false);
  };


  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const onSubmitAuthor = e => {
    let strAuthor = '';
    let strIns = '';
    let strOrcid = '';

    handleClose();

    if (author.authorOrcid)
      strOrcid = orcidTemplate.replace('{authorOrcid}', author.authorOrcid);

    if (author.authorIns)
      strIns = ', ' + author.authorIns;

    if (author.authorName)
    {
      strAuthor = authorTemplate
        .replace('{authorName}', author.authorName)
        .replace('{authorIns}', strIns)
        .replace('{authorOrcid}', strOrcid)
    }

    if (strAuthor)
      jodit.s.insertHTML(strAuthor);
  };

  const onAuthorNameChange = e => {
    setAuthor({...author, authorName: e.target.value });
  };

  const onAuthorInsChange = e => {
    setAuthor({...author, authorIns: e.target.value });
  };

  const onAuthorOrcidChange = e => {
    setAuthor({...author, authorOrcid: e.target.value });
  };

  return (
    <div>
    <Modal show={show} onHide={handleClose} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
        <Modal.Header closeButton>
          <Modal.Title>Insert author</Modal.Title>
        </Modal.Header>
      <Modal.Body>
        <div className="row">
          <div className="col">
            <label className="form-label">Author</label>
            <input
            type="text"
            className="form-control"
            name="author"
            onChange={onAuthorNameChange}
            maxLength={60}
          />
          </div>
          <div className="col">
          <label className="form-label">Institution</label>
          <input
            type="text"
            className="form-control"
            name="ins"
            onChange={onAuthorInsChange}
            maxLength={160}
          />
          </div>
        </div>

        <div className="row">
          <div className="col">
          <label className="form-label">Orcid (url)</label>
          <input
            type="text"
            className="form-control"
            name="orcid"
            onChange={onAuthorOrcidChange}
            maxLength={260}
          />
          </div>
        </div>

      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
        <Button variant="primary" onClick={onSubmitAuthor}>
          Save
        </Button>
      </Modal.Footer>
    </Modal>

      <h2>{state.title}
      <ul className="nav navbar-nav float-xs-right">
      {
        props.auth && <li className="nav-item">
            <button onClick={() => onSubmit()} className="btn btn-outline-dark" disabled={saving}>
              <i className="fa fa-floppy-o" />
            </button>
          </li>
      }
      {
        props.auth && <li className="nav-item">
            <a href={`/posts/${state._id}`} className="btn btn-outline-dark">
              <i className="fa fa-times" />
            </a>
          </li>
      }
    </ul>
      </h2>
      <div className="entry-meta ml-0 mt-0">
          <span>
            <span className="fa fa-user-o"></span>
            <a href={`/author/${state.author}`} title={"Post by " + state.author} rel="author">{state.author}</a>
          </span>
          <span>
            <span className="fa fa-clock-o"></span>
            <time className="entry-date published" dateTime={state.createdAt}>{state.createdAt}</time>
          </span>
      </div>
        {renderErrors()}
        {saving && <div>Data saving in process... please wait!</div>}

        {/* <JoditEditor
                ref={editor}
                  value={content}
                  config={config}
                  tabIndex={1} // tabIndex of textarea
                  onBlur={newContent => setContent(newContent)} // preferred to use only this option to update the content for performance reasons
                  onChange={newContent => {}}
            /> */}

        {!isSSR && (
          <React.Suspense fallback={<div>Loading ...</div>}>
            <Jodit value={content}
                  config={config}
                  tabIndex={1} // tabIndex of textarea
                  onBlur={newContent => setContent(newContent)} // preferred to use only this option to update the content for performance reasons
                  onChange={newContent => {}} 
                  //onChange={newContent => setContent(newContent)}
              />
          </React.Suspense>
        )}
      </div>
  );
  
}

export default PostForm;
